import { ReactNode, useContext, useLayoutEffect } from 'react';
import { BreadcrumbContext, BreadcrumbLevel } from 'src/shared/contexts/BreadcrumbContext';

export function useBreadcrumbLevel(
  level: number,
  name: BreadcrumbLevel['data']['name'] | undefined,
  href?: BreadcrumbLevel['data']['href'],
  options?: {
    component?: ReactNode;
  }
) {
  const context = useContext(BreadcrumbContext);

  if (!context) {
    throw new Error('useBreadcrumbLevel must be used within a BreadcrumbProvider');
  }

  const { register, unregister } = context;

  useLayoutEffect(() => {
    if (!name) {
      return;
    }

    register(level, { name, href, component: options?.component });

    return () => {
      unregister(level);
    };
  }, [level, name, href, options?.component, register, unregister]);
}
